import React from 'react'
import Helmet from 'reactor/components/Helmet'
import BreadcrumbImage from 'assets/images/webLayer.png'
import { List, ListItem } from '@material-ui/core'
import Container from 'reactor/components/Grid/ContainerWithWidth';
import "./PaymentsPage.scss";
import GridItem from 'reactor/components/Grid/GridItem'
import BoxItem from 'reactor/components/Box'
import payment1 from "assets/images/payments/Alinma_Bank_logo.png"
import payment2 from "assets/images/payments/snb.png"

export default function PaymentsPage() {

    return(
        <>
            <Helmet
            bodyClass="payments-methods"
            title="طرق الدفع | رواد لخدمات الويب خبرة أكثر من 12 عام في السوق السعودي"
            description="طرق الدفع المتاحة | رواد لخدمات الويب خبرة أكثر من 12 عام في السوق السعودي"/>
                <Container>
                    <div className="alert">
                        <span>تنوية</span>  فضلاً وليس أمراً نرجوا منكم مراجعة <a href="/rowaad-tos">اتفاقية الاستخدام</a>  قبل الطلب
                    </div>
                    <p className='info'>فضلاً بعد السداد الدخول إلى مركز <a href="https://my.rh.net.sa/index.php?rp=/login" targert="_blank">خدمة العملاء</a> وانشاء تذكرة جديدة تحتوي على تفاصيل الدفع والباقة المطلوب حجزها.</p>
                </Container>
                 <div className='payments'>
                 <Container className='methods-details'>
                    <GridItem xs={12} md={8}>
                        <BoxItem display="flex" justifyContent="space-between">
                            <GridItem md={6}>
                            <div class="pay_box">
                                <img src={payment1} alt='payment1' />
                                <h3>مصرف الانماء</h3>
                                <List >
                                    <ListItem>رقم الحساب: 68202895885000</ListItem>
                                    <ListItem>آيبان: SA5705000068202895885000</ListItem>
                                    <ListItem>صاحب الحساب : شركة رواد الاستضافة لتقنية المعلومات</ListItem>
                                </List>
                            </div>
                            </GridItem>
                            <GridItem md={6}>
                                <div class="pay_box">
                                    <img src={payment2} alt='payment2' />
                                    <h3>البنك الاهلي السعودي</h3>
                                    <List >
                                        <ListItem>رقم الحساب: 37163094000103</ListItem>
                                        <ListItem>آيبان: SA6610000037163094000103‏</ListItem>
                                        <ListItem>صاحب الحساب : شركة رواد الاستضافة لتقنية المعلومات</ListItem>
                                    </List>
                                </div>
                            </GridItem>
                        </BoxItem>
                    </GridItem>
                    <GridItem md={4}>
                        <div className='image hidden-xs-sm'>
                            <img src={BreadcrumbImage} alt=""/>
                        </div>
                    </GridItem>
                </Container>
                 </div>

        </>
    )
}
